import React from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import './RedQuickScrollDialog.scss'
// ===============================|| UI DIALOG - SCROLLABLE ||=============================== //

export type scrollType = 'body' | 'paper' | undefined;

export default function RedQuickScrollDialog(props: any) {
    const theme = useTheme();
    const [scroll, setScroll] = React.useState<scrollType>('body');

    const handleClose = () => {
        if (props.close) {
            props.close();
        }
    };

    const descriptionElementRef: React.Ref<HTMLSelectElement> = React.useRef(null);
    React.useEffect(() => {
        if (props?.open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement?.focus();
            }
        }
    }, [props?.open]);

    return (
        <div style={{
        }}>
            <Dialog
                open={!!props.open || false}
                classes={{
                    root: `red-quick-scroll-dialog ${props.dialogCls}`
                }}
                sx={props.sx || {}}
                onClose={handleClose}
                fullWidth={props.fullWidth === undefined ? true : props.fullWidth}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                {props.dialogTitleEnabled && <DialogTitle id="scroll-dialog-title">Subscribe</DialogTitle>}
                <DialogContent dividers={scroll === 'paper'} className="red-quick-scroll-bar">
                    {props.children}
                </DialogContent>
                {props.dialogActionsEnabled && <DialogActions sx={{ pr: 2.5, pt: 2.5 }}>
                    <Button sx={{ color: theme.palette.error.dark }} onClick={handleClose} color="secondary">
                        Cancel
                    </Button>
                    <Button variant="contained" size="small" onClick={handleClose}>
                        Subscribe
                    </Button>
                </DialogActions>}
            </Dialog>
        </div>
    );
}
